// #region Imports
import { useCallback, useEffect, useState } from 'react';
import servicosApi from '../services/servicosApi';
import { servicoFromBackend } from '../pages/Servicos/servicos-utils';
// #endregion

export default function useServicos() {
	// #region Estado base
	const [servicos, setServicos] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	// #endregion

	// #region Efeito: carga inicial
	useEffect(() => {
		let active = true;
		async function load() {
			setLoading(true);
			setError(null);
			try {
				const raw = await servicosApi.listAll();
				if (!active) return;
				setServicos(raw.map(servicoFromBackend));
			} catch (e) {
				if (active) setError(e);
			} finally {
				if (active) setLoading(false);
			}
		}
		load();
		return () => { active = false; };
	}, []);
	// #endregion

	// #region Listagem (filtros + paginação em memória)
	const listar = useCallback(({ q = '', categoria = 'TODAS', page = 1, pageSize = 10 } = {}) => {
		const norm = q.trim().toLowerCase();
		let filtered = servicos;
		if (norm) {
			filtered = filtered.filter(s =>
				(s.nome || '').toLowerCase().includes(norm) ||
				(s.categoria || '').toLowerCase().includes(norm) ||
				(s.descricao || '').toLowerCase().includes(norm),
			);
		}
		if (categoria !== 'TODAS') filtered = filtered.filter(s => s.categoria === categoria);
		const total = filtered.length;
		const start = (page - 1) * pageSize;
		const data = filtered.slice(start, start + pageSize);
		return { data, total, page, pageSize };
	}, [servicos]);
	// #endregion

	// #region CRUD helpers
	const obter = useCallback(id => servicos.find(s => s.id === id) || null, [servicos]);

	const criar = useCallback(async payload => {
		const dto = await servicosApi.create(payload);
		const inst = servicoFromBackend(dto);
		setServicos(prev => [inst, ...prev]);
		return inst;
	}, []);

	const atualizar = useCallback(async (id, payload) => {
		const dto = await servicosApi.update(id, payload);
		if (!dto) return null;
		const inst = servicoFromBackend(dto);
		setServicos(prev => prev.map(s => (s.id === id ? inst : s)));
		return inst;
	}, []);

	const remover = useCallback(async id => {
		await servicosApi.remove(id);
		setServicos(prev => prev.filter(s => s.id !== id));
	}, []);
	// #endregion

	// #region Export
	return { servicos, loading, error, listar, obter, criar, atualizar, remover };
	// #endregion
}

